export default {
    labelIdle: window.core.localization.filepond.label_idle,
    labelInvalidField: window.core.localization.filepond.label_invalid_field,
    labelFileWaitingForSize: window.core.localization.filepond.label_file_waiting_for_size,
    labelFileSizeNotAvailable: window.core.localization.filepond.label_file_size_not_available,
    labelFileLoading: window.core.localization.filepond.label_file_loading,
    labelFileLoadError: window.core.localization.filepond.label_file_load_error,
    labelFileProcessing: window.core.localization.filepond.label_file_processing,
    labelFileProcessingComplete: window.core.localization.filepond.label_file_processing_complete,
    labelFileProcessingAborted: window.core.localization.filepond.label_file_processing_aborted,
    labelFileProcessingError: window.core.localization.filepond.label_file_processing_error,
    labelFileProcessingRevertError:
        window.core.localization.filepond.label_file_processing_revert_error,
    labelFileRemoveError: window.core.localization.filepond.label_file_remove_error,
    labelTapToCancel: window.core.localization.filepond.label_tap_to_cancel,
    labelTapToRetry: window.core.localization.filepond.label_tap_to_retry,
    labelTapToUndo: window.core.localization.filepond.label_tap_to_undo,
    labelButtonRemoveItem: window.core.localization.filepond.label_button_remove_item,
    labelButtonAbortItemLoad: window.core.localization.filepond.label_button_abort_item_load,
    labelButtonRetryItemLoad: window.core.localization.filepond.label_button_retry_item_load,
    labelButtonAbortItemProcessing:
        window.core.localization.filepond.label_button_abort_item_processing,
    labelButtonUndoItemProcessing:
        window.core.localization.filepond.label_button_undo_item_processing,
    labelButtonRetryItemProcessing:
        window.core.localization.filepond.label_button_retry_item_processing,
    labelButtonProcessItem: window.core.localization.filepond.label_button_process_item,
    labelMaxFileSizeExceeded: window.core.localization.filepond.label_max_file_size_exceeded,
    labelFileTypeNotAllowed: window.core.localization.filepond.label_file_type_not_allowed,
};
